export default __webpack_public_path__ + "static/media/manifest-printout-placeholder.08280fc6.svg";